import { put, call } from "redux-saga/effects";
import { SagaIterator } from "redux-saga";
import { fetchDataSummarySuccessVPO, fetchDataSummaryRequestVPO } from "./data-summary";
import { fetchDataSummaryVPO } from "../../api/api";

export function* handleFetchDataSummaryVPO(action: ReturnType<typeof fetchDataSummaryRequestVPO>): SagaIterator {
  const params = action.payload;
  const data = yield call(fetchDataSummaryVPO, params);
  yield put(fetchDataSummarySuccessVPO({ data, params }));
}
